import { render } from "./HistoryViewer.vue?vue&type=template&id=e3c51498"
import script from "./HistoryViewer.vue?vue&type=script&lang=js"
export * from "./HistoryViewer.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__